import { useUpdateMarketplaceMutation } from '@anytag/graphql';
import { THEME } from '@anytag/shared-constants';
import { useQueryHelper } from '@anytag/shared-hooks';
import {
  MarketplaceFormValues,
  MarketplaceCampaignForms,
  useUpdateMarketplaceStatus,
  getCreateUpdateMarketplaceInput
} from '@anytag/shared-organisms';
import { FormAction } from '@anytag/shared-types';
import { useMarketplaceDetailsContext } from '../marketplace-details-context';

export const EditMarketplaceCampaign = () => {
  const { marketplace } = useMarketplaceDetailsContext();
  const { t, enqueueSnackbar, invalidateRouteLoader } = useQueryHelper();
  const { ApproveRejectWarningBar, DialogModals } = useUpdateMarketplaceStatus({ marketplace });
  const { callUpdateMarketplace } = useUpdateMarketplaceMutation({
    onCompleted: invalidateRouteLoader
  });

  const handleSubmit: FormAction<MarketplaceFormValues>['onSubmit'] = async (values) => {
    try {
      await callUpdateMarketplace({
        variables: { input: { ...getCreateUpdateMarketplaceInput(values), id: marketplace.id } }
      });
      enqueueSnackbar(t('succeededInUpdating', { name: values.title }), { variant: 'success' });
    } catch (error) {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    }
  };

  return (
    <div css={{ boxShadow: THEME.shadows.boxShadow }}>
      <ApproveRejectWarningBar />
      <MarketplaceCampaignForms onSubmit={handleSubmit} data={marketplace} type={marketplace.campaignType} />
      {DialogModals}
    </div>
  );
};
